<template>
  <v-container>
      <v-flex>
        <v-card>
          <v-tabs 
            class="tableTabs"
            slider-color="primary"
            light
            color="grey lighten-4"
            card 
          >
            <v-tab>
              <img class="navIcons" src="@/assets/img/icons/transaction.png" alt="transaction" />
              &nbsp;Transaction
            </v-tab>
            <v-tab-item>
              <Transaction/>
            </v-tab-item>
            <!-- <v-tab>
              Comments
            </v-tab>
            <v-tab-item :key="Comments">
              <Transaction/>
            </v-tab-item> -->
          </v-tabs>
        </v-card>
      </v-flex>
  </v-container>
</template>


<script>
import Transaction from './transaction.vue';

export default {
  name: 'TransactionContainer',
  components: {
    Transaction,
  },
};

</script>

<style lang="scss">
</style>